export default "__VITE_ASSET__BL5SL00e__"